import React, { useEffect, useState } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import Layout from "../Layout";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";

const Turnover = () => {
  const { t } = useTranslation();
  const [data, setData] = useState({});
  const [filter, setFilter] = useState({
    status: "active",
    page: 1,
    limit: 100,
  });

  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getTurnover, filter);
    if (status == 200) {
      if (data?.success) {
        setData(data?.results);
      }
    }
  };

  useEffect(() => {
    getData();
  }, [filter?.status]);

  const list = data?.data || [];

  return (
    <Layout>
      <div>
        <div className="history-overview-wrapper">
          <div className="row no-gutters justify-center">
            <div className="mobile-history-card v-card v-sheet theme--light elevation-0">
              <div className="text-center col col-12">
                <button
                  type="button"
                  onClick={() => setFilter({ ...filter, status: "active" })}
                  className={`history-tab-mobile v-btn v-btn--has-bg theme--light v-size--default ${
                    filter?.status === "active" ? "primary" : ""
                  }`}
                >
                  <span className="v-btn__content">
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate mobile-icon material-icons theme--light"
                    >
                      cached
                    </i>
                    <span>
                      <span>{t("Running")}</span>
                    </span>
                  </span>
                </button>
                <button
                  type="button"
                  onClick={() =>
                    setFilter({ ...filter, status: "completed" })
                  }
                  className={`history-tab-mobile v-btn v-btn--has-bg theme--light v-size--default ${
                    filter?.status === "completed" ? "primary" : ""
                  }`}
                >
                  <span className="v-btn__content">
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate mobile-icon material-icons theme--light"
                    >
                      sports_soccer
                    </i>
                    <span>{t("Completed")}</span>
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div className="v-card v-sheet theme--light elevation-0">
            {list?.length > 0 ? (
              list.map((res) => (
                <div
                  key={res?._id}
                  className="row mx-1 mobile-reward-table"
                >
                  <div className="mr-0 col col-6">
                    <div className="row reward-table-header pl-6 no-gutters">
                      <div className="col col-12">{t("Type")}</div>
                      <div className="col col-12">{t("OriginalAmount")}</div>
                      <div className="col col-12">{t("Amount")}</div>
                      <div className="col col-12">{t("Status")}</div>
                      <div className="col col-12">{t("CreatedTime")}</div>
                    </div>
                  </div>
                  <div className="col col-6">
                    <div className="row no-gutters">
                      <div className="col col-12">
                        {res?.isBonusTurnover ? t("Bonus") : t("Normal")}
                      </div>
                      <div
                        className="col col-12"
                        style={{
                          color:
                            res?.transactionType === "credit"
                              ? "green"
                              : "red",
                        }}
                      >
                        {Number(res?.originalAmount).toFixed(2)}
                      </div>
                      <div className="col col-12">
                        {res?.usedAmount > 0 &&
                        res?.usedAmount != Number(res?.originalAmount)
                          ? Number(res?.usedAmount).toFixed(2)
                          : ""}
                      </div>
                      <div className="col col-12">{res?.status}</div>
                      <div className="col col-12">
                        {moment(res?.insertDate).format(
                          "YYYY-MM-DD hh:mm:ss",
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col col-12">
                    <hr
                      role="separator"
                      aria-orientation="horizontal"
                      className="mx-2 v-divider theme--light"
                    />
                  </div>
                </div>
              ))
            ) : (
              <div className="history-card v-card v-sheet theme--light elevation-0">
                <div className="row no-gutters">
                  <div className="col col-12">
                    <p className="text-center my-4">
                      {t("NoPendingTicketFound")}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        
        </div>
   
      </div>
    </Layout>
  );
};

export default Turnover;
